module.exports = __webpack_public_path__ + "img/dfm-logo.76598989.png";